import {del, get, patch, post} from "./request";

export const technicianApi = {};

technicianApi.getAll = async ({page, size, signal, ...props}) => {
  try {
    const {data} = await post(
      `/technician/all`,
      props,
      {size, page},
      {signal},
    );
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
technicianApi.update = async ({id, body}) => {
  try {
    const {data} = await patch(`/technician/update/${id}`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

technicianApi.getOne = async ({id}) => {
  try {
    const {data} = await get(`/technician/one/${id}`);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

technicianApi.updateSubCategory = async ({body}) => {
  try {
    const {data} = await post(`/subCategory/addTechnicianSubCategories`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const bancApi = {};

bancApi.add = async ({body}) => {
  try {
    const {data} = await post(`/bankAccount/add`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
bancApi.update = async ({body, id}) => {
  try {
    const {data} = await patch(`/bankAccount/update/${id}`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
bancApi.delete = async (id) => {
  try {
    const {data} = await del(`/bankAccount/delete/${id}`);
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
bancApi.getConnectStatus = async () => {
  try {
    const {data} = await get("/bankAccount/connect/status");
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
bancApi.startConnectOnboarding = async (purpose = "onboarding") => {
  try {
    const {data} = await post("/bankAccount/connect/onboarding", {
      clientType: "web",
      purpose,
    });
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const interventionAreaApi = {};
interventionAreaApi.add = async ({interventionAreaList}) => {
  try {
    const {data} = await post(`/interventionArea/addTechnicianAreas`, {
      interventionAreaList,
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};
interventionAreaApi.delete = async ({interventionAreaIds}) => {
  try {
    const {data} = await post(`/interventionArea/deleteTechnicianAreas`, {
      interventionAreaIds,
    });
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

export const userApi = {};
userApi.update = async ({id, body}) => {
  try {
    const {data} = await patch(`/user/update/${id}`, body);
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

userApi.block = async ({blockedId}) => {
  try {
    const {data} = await post(`/user/blockUser`, {blockedId});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

userApi.contactSupport = async ({subject, content}) => {
  try {
    const {data} = await post("/user/contactSupport", {
      subject,
      content,
    });
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};

userApi.unBlock = async ({blockedId}) => {
  try {
    const {data} = await post(`/user/unblockUser`, {blockedId});
    return data;
  } catch (err) {
    return Promise.reject(err);
  }
};

userApi.listBlocked = async (filter, props) => {
  try {
    const {data} = await post(`/user/blockedUsers`, {...filter}, {...props});
    return data;
  } catch (error) {
    return Promise.reject(error);
  }
};
